import styled from "styled-components";

const StyledTHead = styled.thead``;

export const TableHead = (props: any) => {
  const { children } = props;

  return <StyledTHead>{children}</StyledTHead>;
};
